module.exports = __webpack_public_path__ + "img/BOWTIE 1 PURPLE.13394ea.svg";